<template>
  <div class="container">
    <HeaderComponent/>

    <div class="inner-container">
      <div class="inner-container-left">
        <h3 style="margin: 30px 0">{{ detail.post_title }}</h3>
        <div class="cell-row"
             style="padding-bottom: 20px;margin-bottom: 20px;font-size: 14px;border-bottom: 1px solid #d2d2d2">
          <span>发布于： {{ detail.post_date }}</span>
          <span style="margin-left: 20px;">浏览： {{ detail.views_count }}</span>
        </div>
        <div class="span-content" v-html="detail.post_content">
        </div>
      </div>
      <div class="inner-container-right">
        <RightNewsComponent/>
        <div style="height: 20px;"/>
        <RightHuoDongComponent/>
      </div>
    </div>
    <FooterComponent/>
  </div>
</template>

<script>
import HeaderComponent from "@/components/HeaderComponent";
import FooterComponent from "@/components/FooterComponent";
import RightHuoDongComponent from "@/components/RightHuoDongComponent"
import RightNewsComponent from "@/components/RightNewsComponent"
import http from "@/util/http";

export default {
  name: "DetailPage",
  components: {FooterComponent, HeaderComponent, RightHuoDongComponent, RightNewsComponent},
  data() {
    return {
      detail: {
        post_content: undefined,
        post_date: undefined,
        post_title: undefined,
        views_count: undefined
      }
    }
  },
  mounted() {
    this._getDetail()
  },
  methods: {
    _getDetail() {
      http.get('articleDetail', {p: this.$route.query.p})
          .then((res) => {
            if (res.data.status === 0) {
              this.detail = res.data.data
              this.detail.post_content = this.detail.post_content.replace(/\n/gm,"<br/>")
            }
          })
    }
  }
}
</script>

<style scoped>

.inner-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}

.inner-container-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.inner-container-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-left: 20px;
}

.cell-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.span-content {
  text-align: start;
  color: #333333;
}
</style>